import(/* webpackMode: "eager", webpackExports: ["ProjectsClient"] */ "/vercel/path0/web/app/(app)/projects/projects-client.tsx");
